import React, { useCallback, useEffect, useState } from "react";
import { Grid, useMediaQuery } from "@mui/material";
import {
  ArrayField,
  Datagrid,
  TextField,
  SimpleShowLayout,
  FunctionField,
  Labeled,
  useDataProvider,
} from "react-admin";
import { settings } from "app";
import HealthInsuranceModal from "../Modals/HealthInsuranceModal";
import permissions from "app/permissions";
import { getUniName } from "utils/tenants";
import SecuredComponent from "server/security/SecuredComponent";
import { studentRequests } from "api/studentApi";
import HealthInsuranceNumberModal from "../Modals/HealthInsuranceNumberModal";

const HealthCareData = ({ record, isForeigner }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const dataProvider = useDataProvider();
  const tenant = settings.tenant;
  const uniDisplayName = getUniName(tenant);
  const [healthInsurance, setHealthInsurance] = useState(null);

  // The health insurance number is only relevant for foreign students insured by the university
  const showHealthInsuranceNumber = isForeigner && record?.healthCareEvents?.at(-1)?.needsInsurance === true;

  const fetchHealthInsurance = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(
        studentRequests.getStudentHealthInsurance(record?.studentId),
        null,
        "GET",
      );
      setHealthInsurance(data || {});
    } catch (err) {
      // 404 means the student has no health insurance number yet — fall back to an empty record
      console.error(err);
      setHealthInsurance({});
    }
  }, [dataProvider, record?.studentId]);
  useEffect(() => {
    if (!record?.studentId || !showHealthInsuranceNumber) return;
    fetchHealthInsurance();
  }, [record?.studentId, showHealthInsuranceNumber, fetchHealthInsurance]);

  return (
    <SimpleShowLayout>
      <Grid
        spacing={2}
        container
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <ArrayField
            source="healthCareEvents"
            label=" "
          >
            <Datagrid
              rowClick={false}
              bulkActionButtons={false}
              sx={settings.style.secondaryDatagrid}
            >
              <FunctionField
                label="Има здравна застраховка"
                render={record =>
                  record.needsInsurance ? `Осигурява се от ${uniDisplayName}` : `Не се осигурява от ${uniDisplayName}`
                }
              />
              <TextField
                source="fromFormatted"
                label="От дата"
                sortable={false}
              />
            </Datagrid>
          </ArrayField>
        </Grid>
        <Grid
          item
          xs={12}
        >
          <SecuredComponent permission={permissions.canUpdateHealthCareInfo}>
            <HealthInsuranceModal />
          </SecuredComponent>
        </Grid>
        {showHealthInsuranceNumber && (
          <SecuredComponent permission={permissions.canPreviewStudentInfo}>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Номер на здравно осигуряване">
                <TextField
                  source="healthInsuranceNumber"
                  record={healthInsurance}
                  emptyText="Няма посочен"
                />
              </Labeled>
              <SecuredComponent permission={permissions.canUpdateStudentInfo}>
                <div>
                  <HealthInsuranceNumberModal
                    healthInsurance={healthInsurance}
                    record={record}
                    fetchHealthInsurance={fetchHealthInsurance}
                  />
                </div>
              </SecuredComponent>
            </Grid>
          </SecuredComponent>
        )}
      </Grid>
    </SimpleShowLayout>
  );
};

export default HealthCareData;
